import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PassengerDetailsUpdateRQ } from 'src/app/model/request/passenger-details-update-screen-request';
import { Passenger, PassengerDetailScreen } from 'src/app/model/screen/passenger-detail-screen';
import { ApiService } from 'src/app/service/api.service';
import { CommonService } from 'src/app/service/common.service';
import { ContentfulService } from 'src/app/service/contentful.service';
import { LocalAssetReaderService } from 'src/app/service/local-asset-reader.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { XmlToJsonParserService } from 'src/app/service/xml-to-json-parser.service';
import findOrderJSON from 'src/assets/json/find-order/request/find-order-default-params.json';
import reQuoteOrderJSON from 'src/assets/json/order-reshop/requote/request/requote-request-default-params.json';

@Component({
  selector: 'app-passenger-details-screen',
  templateUrl: './passenger-details-screen.component.html',
  styleUrls: ['./passenger-details-screen.component.scss']
})
export class PassengerDetailsScreenComponent implements OnInit {
  passengerDetailsForm: any = false;
  selectedPassengerDetail = {} as Passenger;
  passengerDetailScreenData = {} as PassengerDetailScreen;
  public nationalities: any[] = [];
  public showMyMessage: boolean = false;
  validFQTVList: any = [];
  givenFQTVList: any = [];

  passengerDetailsUpdateRQ: PassengerDetailsUpdateRQ = {} as PassengerDetailsUpdateRQ;
  confirmBookingScreenData: string | undefined;
  public passengerDetail: any[] = [];
  yourBookingScreenData: any;
  emailAddress: any;
  contactInfo: any[] = [];
  public phoneContact: any;
  public Street1: any;
  public Street2: any;
  public cityName: any;
  public zipCode: any;
  identity: any = [
    { value: 'PT', name: 'Passport' },
    { value: '709', name: 'Identity Card' },
    // { value: 'AEA', name: 'Redress Number' }
  ];
  gender: any = ['Male', 'Female'];
  loyaltyProgram: any = ['Airline'];
  userPrefixName: any = ['Mr', 'Mrs', 'Miss', 'Ms', 'Dr'];

  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private sandboxPageStateService: SandboxPageStateService,
    private localAssetReaderService: LocalAssetReaderService,
    private xmlToJsonParserService: XmlToJsonParserService,
    private apiService: ApiService,
    private contentfulService: ContentfulService
  ) {
    const query = { 'fields.name': 'FQTV Card Numbers#SANDBOX' };
    this.contentfulService.getMenuContentWithItems(query).then((items) => {
      let fqtvNumberDetails = items[0]?.fields.jsonData;
      this.givenFQTVList = fqtvNumberDetails;
      fqtvNumberDetails.forEach((fqtvNumberDetail: any) => {
        this.validFQTVList.push(fqtvNumberDetail.cardNumber);
      });
    });
    {
      Object.entries(findOrderJSON).forEach((entry) => {
        const [key, value] = entry;
        this.inputParamsMap.set(key, value);
      });
      Object.entries(reQuoteOrderJSON).forEach((entry) => {
        const [key, value] = entry;
        this.reQuoteInputParamsMap.set(key, value);
      });
    }
  }

  inputParamsMap = new Map();
  reQuoteInputParamsMap = new Map();

  getNationalities() {
    return this.commonService.getCountries();
  }

  // loyaltyProgram: any = ['Avios', 'On Business', 'Airline'];

  ngOnInit(): void {
    this.passengerDetailScreenData = this.sandboxPageStateService.getPassengerDetailScreenData();
    this.passengerDetailsForm = this.initPassengerDetailForm();
    setTimeout(() => {
      this.nationalities = this.getNationalities();
    }, 1000);
    //EXISTING FUNCTIONALITY
    let givenAddress: any = '';
    let jsonRequest: any = '';
    if (this.passengerDetailScreenData.bookingPassengerDetailType === 'offer-price-screen-passenger') {
      jsonRequest = this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.AIRLINE_OFFERS_SCREEN_URL);
      jsonRequest = JSON.parse(jsonRequest);
      givenAddress = jsonRequest['S:Envelope']['S:Body'].OfferPriceRQ.Party.Sender.TravelAgencySender.Contacts.Contact;
    } else if (this.passengerDetailScreenData.bookingPassengerDetailType === 'your-booking-screen-passenger') {
      if (this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.FIND_ORDER_SCREEN_URL)) {
        jsonRequest = this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.FIND_ORDER_SCREEN_URL);
        jsonRequest = JSON.parse(jsonRequest);
        givenAddress = jsonRequest['S:Envelope']['S:Body'].OrderRetrieveRQ.Party.Sender.TravelAgencySender.Contacts.Contact;
        let contactProvided: any[] =
          this.sandboxPageStateService.getYourBookingScreenData().jsonData['SOAP:ENVELOPE']['SOAP:BODY'][0].ORDERVIEWRS[0].RESPONSE[0].DATALISTS[0].CONTACTLIST[0].CONTACTINFORMATION[0]
            .CONTACTPROVIDED;
        contactProvided.forEach((item: any) => {
          this.phoneContact = item.PHONE;
        });
      } else {
        jsonRequest = this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.OFFER_PRICE_SCREEN_ORDER_CREATE_URL);
        jsonRequest = JSON.parse(jsonRequest);
        givenAddress = jsonRequest['S:Envelope']['S:Body'].OrderCreateRQ.Party.Sender.TravelAgencySender.Contacts.Contact;
      }
    }
    let addressContact = givenAddress.AddressContact;
    this.cityName = addressContact.CityName;
    this.zipCode = addressContact.PostalCode;
    this.Street1 = addressContact.Street[0];
    this.Street2 = addressContact.Street[1];
    this.emailAddress = givenAddress.EmailContact.Address;
    //END
  }
  initPassengerDetailForm() {
    let activePassengerIndex = this.passengerDetailScreenData.activePassengerIndex;
    let passengerList: Passenger[] = this.passengerDetailScreenData.passengerDetail;
    this.selectedPassengerDetail = passengerList[activePassengerIndex];
    let documentType: any = 'identityDocument';
    if (typeof this.selectedPassengerDetail.documentType !== 'undefined') {
      documentType = this.selectedPassengerDetail.documentType;
    }
    let nationalities = 'GBR';
    if (typeof this.selectedPassengerDetail.nationalities !== 'undefined') {
      nationalities = this.selectedPassengerDetail.nationalities;
    }
    let isAddressChecked: boolean = false;
    if (typeof this.selectedPassengerDetail.enableAddressDetail !== 'undefined') {
      isAddressChecked = this.selectedPassengerDetail.enableAddressDetail;
    }
    let country = '';
    if (typeof this.selectedPassengerDetail.country !== 'undefined') {
      country = this.selectedPassengerDetail.country;
    }
    let loyaltyProgram = '';
    if (typeof this.selectedPassengerDetail.loyaltyProgram !== 'undefined') {
      loyaltyProgram = this.selectedPassengerDetail.loyaltyProgram;
    }
    return this.formBuilder.group({
      passengerDetail: this.formBuilder.group({
        passengerID: [this.selectedPassengerDetail.passengerId],
        passengerNameTitle: [this.capitalizeFirstLetter(this.selectedPassengerDetail.passengerNameTitle)],
        passengerName: [this.selectedPassengerDetail.passengerName],
        passengerSurName: [this.selectedPassengerDetail.passengerSurName],
        passengerDOB: [this.selectedPassengerDetail.passengerDOB],
        passengerGender: [this.selectedPassengerDetail.passengerGender],
        nationalities: [nationalities]
      }),
      passengerIdentityDetail: this.formBuilder.group({
        identity: [this.selectedPassengerDetail.identity],
        idnumber: [this.selectedPassengerDetail.idnumber],
        redressNumber: [this.selectedPassengerDetail.redressNumber],
        issuingCountry: [this.selectedPassengerDetail.issuingCountry],
        expiryDate: [this.selectedPassengerDetail.expiryDate]
      }),
      passengerLoyaltyDetail: this.formBuilder.group({
        loyaltyProgram: [loyaltyProgram],
        loyaltyProgramNumber: [this.selectedPassengerDetail.loyaltyProgramNumber]
      }),
      passengerAddressDetail: this.formBuilder.group({
        enableAddressDetail: [isAddressChecked],
        address1: [this.selectedPassengerDetail.address1],
        address2: [this.selectedPassengerDetail.address2],
        city: [this.selectedPassengerDetail.city],
        zip: [this.selectedPassengerDetail.zip],
        country: [country]
      }),
      passengerDocumentType: [documentType]
    });
  }
  capitalizeFirstLetter(string: any) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  inp_group(controlName: any) {
    return this.passengerDetailsForm.controls[controlName] as FormGroup;
  }
  inp_group_value(controlName: any) {
    return this.inp_group(controlName).value;
  }
  inp_passengerDetail_group(controlName: any) {
    return this.inp_group('passengerDetail').controls[controlName] as FormGroup;
  }
  inp_passengerDetail_group_value(controlName: any) {
    return this.inp_passengerDetail_group(controlName).value;
  }
  inp_passengerIdentityDetail_group(controlName: any) {
    return this.inp_group('passengerIdentityDetail').controls[controlName] as FormGroup;
  }
  inp_passengerIdentityDetail_group_value(controlName: any) {
    return this.inp_passengerIdentityDetail_group(controlName).value;
  }
  inp_passengerLoyaltyDetail_group(controlName: any) {
    return this.inp_group('passengerLoyaltyDetail').controls[controlName] as FormGroup;
  }
  inp_passengerLoyaltyDetail_group_value(controlName: any) {
    return this.inp_passengerLoyaltyDetail_group(controlName).value;
  }
  inp_passengerAddressDetail_group(controlName: any) {
    return this.inp_group('passengerAddressDetail').controls[controlName] as FormGroup;
  }
  inp_passengerAddressDetail_group_value(controlName: any) {
    return this.inp_passengerAddressDetail_group(controlName).value;
  }
  closePanel() {
    if (this.passengerDetailScreenData.bookingPassengerDetailType === 'offer-price-screen-passenger') {
      let patchSandboxSourceData = { mainMenu: 'offer-price' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
    if (this.passengerDetailScreenData.bookingPassengerDetailType === 'your-booking-screen-passenger') {
      let patchSandboxSourceData = { mainMenu: 'your-booking-screen' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }
  validateFqtvNumber(fqtvNumber: any, passengerName: any, passengerSureName: any) {
    if (passengerName === '' || passengerName === null || passengerSureName === '' || passengerSureName === null) {
      return false;
    } else {
      passengerName = passengerName.trim();
      passengerSureName = passengerSureName.trim();
      passengerName = passengerName.toLowerCase();
      passengerSureName = passengerSureName.toLowerCase();
      if (this.validFQTVList.indexOf(fqtvNumber) !== -1) {
        let matchedFqtvFound: boolean = false;
        this.givenFQTVList.forEach((fqtvDetail: any) => {
          if (!matchedFqtvFound && fqtvDetail.cardNumber === fqtvNumber) {
            fqtvDetail.lastname = fqtvDetail.lastname.trim();
            fqtvDetail.firstname = fqtvDetail.firstname.trim();
            fqtvDetail.lastname = fqtvDetail.lastname.toLowerCase();
            fqtvDetail.firstname = fqtvDetail.firstname.toLowerCase();
            if (fqtvDetail.firstname === passengerName && fqtvDetail.lastname === passengerSureName) {
              matchedFqtvFound = true;
            }
          }
        });
        return matchedFqtvFound;
      } else {
        return false;
      }
    }
  }
  onSubmit() {
    this.showMyMessage = false;
    let passengerFormDetail = this.passengerDetailsForm.value;
    let isValidFQTV: boolean = true;
    let loyaltyProgramNumber = passengerFormDetail.passengerLoyaltyDetail.loyaltyProgramNumber;
    let passengerDetail = passengerFormDetail.passengerDetail;
    if (loyaltyProgramNumber !== '' && loyaltyProgramNumber !== null) {
      loyaltyProgramNumber = loyaltyProgramNumber.trim();
    }
    if (this.passengerDetailScreenData.bookingPassengerDetailType === 'offer-price-screen-passenger') {
      if (loyaltyProgramNumber !== '' && loyaltyProgramNumber !== null) {
        isValidFQTV = this.validateFqtvNumber(loyaltyProgramNumber, passengerDetail.passengerName, passengerDetail.passengerSurName);
      }
    } else if (this.passengerDetailScreenData.bookingPassengerDetailType === 'your-booking-screen-passenger') {
      let documentType = this.inp_group_value('passengerDocumentType');
      if (documentType === 'loyaltyProgram') {
        if (loyaltyProgramNumber !== '' && loyaltyProgramNumber !== null) {
          isValidFQTV = this.validateFqtvNumber(loyaltyProgramNumber, passengerDetail.passengerName, passengerDetail.passengerSurName);
        }
      }
    }
    if (!isValidFQTV) {
      let patchSandboxSourceData: any = '';
      patchSandboxSourceData = { showError: 'Yes', errorMessage: 'Invalid FQTV Number' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let passengerListScreenDetail = this.passengerDetailScreenData;
      let activePassengerIndex = passengerListScreenDetail.activePassengerIndex;

      let selectedPassengerDetail = passengerListScreenDetail.passengerDetail[activePassengerIndex];
      selectedPassengerDetail.passengerNameTitle = passengerFormDetail.passengerDetail.passengerNameTitle;
      selectedPassengerDetail.passengerName = passengerFormDetail.passengerDetail.passengerName;
      selectedPassengerDetail.passengerSurName = passengerFormDetail.passengerDetail.passengerSurName;
      selectedPassengerDetail.passengerDOB = passengerFormDetail.passengerDetail.passengerDOB;
      selectedPassengerDetail.passengerGender = passengerFormDetail.passengerDetail.passengerGender;
      selectedPassengerDetail.nationalities = passengerFormDetail.passengerDetail.nationalities;
      selectedPassengerDetail.redressNumber = passengerFormDetail.passengerDetail.redressNumber;

      selectedPassengerDetail.enableAddressDetail = false;
      selectedPassengerDetail.address1 = '';
      selectedPassengerDetail.address2 = '';
      selectedPassengerDetail.city = '';
      selectedPassengerDetail.zip = '';
      selectedPassengerDetail.country = '';
      if (passengerFormDetail.passengerAddressDetail.enableAddressDetail) {
        selectedPassengerDetail.enableAddressDetail = passengerFormDetail.passengerAddressDetail.enableAddressDetail;
        selectedPassengerDetail.address1 = passengerFormDetail.passengerAddressDetail.address1;
        selectedPassengerDetail.address2 = passengerFormDetail.passengerAddressDetail.address2;
        selectedPassengerDetail.city = passengerFormDetail.passengerAddressDetail.city;
        selectedPassengerDetail.zip = passengerFormDetail.passengerAddressDetail.zip;
        selectedPassengerDetail.country = passengerFormDetail.passengerAddressDetail.country;
      }

      selectedPassengerDetail.identity = '';
      selectedPassengerDetail.idnumber = '';
      selectedPassengerDetail.expiryDate = '';
      selectedPassengerDetail.issuingCountry = '';
      selectedPassengerDetail.loyaltyProgram = '';
      selectedPassengerDetail.loyaltyProgramNumber = '';

      let documentType = this.inp_group_value('passengerDocumentType');
      if (this.passengerDetailScreenData.bookingPassengerDetailType === 'your-booking-screen-passenger') {
        if (documentType === 'loyaltyProgram') {
          selectedPassengerDetail.documentType = 'loyaltyProgram';
          selectedPassengerDetail.loyaltyProgram = passengerFormDetail.passengerLoyaltyDetail.loyaltyProgram;
          selectedPassengerDetail.loyaltyProgramNumber = passengerFormDetail.passengerLoyaltyDetail.loyaltyProgramNumber;
        } else {
          selectedPassengerDetail.documentType = 'identityDocument';
          selectedPassengerDetail.identity = passengerFormDetail.passengerIdentityDetail.identity;
          selectedPassengerDetail.idnumber = passengerFormDetail.passengerIdentityDetail.idnumber;
          selectedPassengerDetail.expiryDate = passengerFormDetail.passengerIdentityDetail.expiryDate;
          selectedPassengerDetail.issuingCountry = passengerFormDetail.passengerIdentityDetail.issuingCountry;
          selectedPassengerDetail.redressNumber = passengerFormDetail.passengerIdentityDetail.redressNumber;
        }
      } else {
        selectedPassengerDetail.documentType = 'loyaltyProgram';
        selectedPassengerDetail.loyaltyProgram = passengerFormDetail.passengerLoyaltyDetail.loyaltyProgram;
        selectedPassengerDetail.loyaltyProgramNumber = passengerFormDetail.passengerLoyaltyDetail.loyaltyProgramNumber;
        selectedPassengerDetail.documentType = 'identityDocument';
        selectedPassengerDetail.identity = passengerFormDetail.passengerIdentityDetail.identity;
        selectedPassengerDetail.idnumber = passengerFormDetail.passengerIdentityDetail.idnumber;
        selectedPassengerDetail.expiryDate = passengerFormDetail.passengerIdentityDetail.expiryDate;
        selectedPassengerDetail.issuingCountry = passengerFormDetail.passengerIdentityDetail.issuingCountry;
        selectedPassengerDetail.redressNumber = passengerFormDetail.passengerIdentityDetail.redressNumber;
      }
      this.passengerDetailScreenData.passengerDetail[activePassengerIndex] = selectedPassengerDetail;
      this.sandboxPageStateService.updatePassengerDetailScreenData(this.passengerDetailScreenData);
      if (this.passengerDetailScreenData.bookingPassengerDetailType === 'your-booking-screen-passenger') {
        this.initPassengerDetailUpdateRequest();
      } else {
        this.closePanel();
        this.showMyMessage = true;
      }
    }
  }
  async initPassengerDetailUpdateRequest() {
    let passengerScreenDetails = this.sandboxPageStateService.getPassengerDetailScreenData();
    let bookingDetail = passengerScreenDetails.bookingPassengerDetailType;
    let activePassengerIndex = passengerScreenDetails.activePassengerIndex;
    let passengerList = passengerScreenDetails.passengerDetail;
    let selectedPasssenger = passengerList[activePassengerIndex];
    let pnr = passengerScreenDetails.pnrNumber;
    let ActionType = 'ADD';
    let owner = 'BA';
    let contactID = 'ContactInfo-' + selectedPasssenger.passengerId;
    let contactinfoRef = 'ContactInfo-' + selectedPasssenger.passengerId;

    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.ORDERCHANGE_PASSENGER_DETAILS_UPDATE_TEMPLATE);
    this.passengerDetailsUpdateRQ = JSON.parse(jsonRequestTemplate as any);
    this.passengerDetailsUpdateRQ['S:Envelope'].$['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.passengerDetailsUpdateRQ['S:Envelope'].$['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.passengerDetailsUpdateRQ['S:Envelope']['SOAP-ENV:Header'] = '';
    this.passengerDetailsUpdateRQ['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
    this.passengerDetailsUpdateRQ['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
    this.passengerDetailsUpdateRQ['S:Envelope']['S:Body']!.OrderChangeRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
    this.passengerDetailsUpdateRQ['S:Envelope']['S:Body']!.OrderChangeRQ.$.Version = '17.2';
    this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderID._ = pnr;
    this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderID.$.Owner = owner;
    this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.Query.PassengerServicing.New.$.PassengerID = selectedPasssenger.passengerId;
    this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.Query.PassengerServicing.New.Individual.GivenName = selectedPasssenger.passengerName;
    this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.Query.PassengerServicing.New.Individual.Surname = selectedPasssenger.passengerSurName;
    if (selectedPasssenger.documentType === 'identityDocument') {
      delete this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.Query.PassengerServicing.New.LoyaltyProgramAccount;
      this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.Query.PassengerServicing.New.IdentityDocument = [
        {
          IdentityDocumentNumber: selectedPasssenger.idnumber,
          IdentityDocumentType: selectedPasssenger.identity,
          IssuingCountryCode: selectedPasssenger.issuingCountry,
          CitizenshipCountryCode: selectedPasssenger.nationalities,
          ResidenceCountryCode: selectedPasssenger.nationalities,
          ExpiryDate: selectedPasssenger.expiryDate,
          Birthdate: selectedPasssenger.passengerDOB,
          Gender: selectedPasssenger.passengerGender
        }
      ];
      if (selectedPasssenger.redressNumber !== '' && selectedPasssenger.redressNumber !== null && typeof selectedPasssenger.redressNumber !== 'undefined') {
        this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.Query.PassengerServicing.New.IdentityDocument.push({
          IdentityDocumentNumber: selectedPasssenger.redressNumber,
          IdentityDocumentType: 'AEA',
          IssuingCountryCode: selectedPasssenger.issuingCountry
        });
      }
      if (selectedPasssenger.identity === null || selectedPasssenger.identity === '') {
        delete this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.Query.PassengerServicing.New.IdentityDocument;
      }
    } else {
      delete this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.Query.PassengerServicing.New.IdentityDocument;
      this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.Query.PassengerServicing.New.LoyaltyProgramAccount = {
        Airline: {
          AirlineDesignator: owner
        },
        ProgramName: selectedPasssenger.loyaltyProgram,
        AccountNumber: selectedPasssenger.loyaltyProgramNumber
      };

      //if (this.passengerDetailsForm.value.loyaltyProgram === '' || undefined || 'Airline') {
      delete this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.Query.PassengerServicing.New.LoyaltyProgramAccount.ProgramName;
      //}
      if (selectedPasssenger.loyaltyProgramNumber === '' || selectedPasssenger.loyaltyProgramNumber === null) {
        delete this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.Query.PassengerServicing.New.LoyaltyProgramAccount;
      }
    }

    if (selectedPasssenger.enableAddressDetail) {
      this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.Query.PassengerServicing.New.ContactInfoRef = contactinfoRef;
    } else {
      delete this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.Query.PassengerServicing.New.ContactInfoRef;
    }

    this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.Query.PassengerServicing.New.ActionType = ActionType;

    this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.ContactList.ContactInformation.$.ContactID = contactID;
    let address1 = this.Street1;
    let address2 = this.Street2;
    let city = this.cityName;
    let zip = this.zipCode;
    let country: any = 'GB';
    if (selectedPasssenger.address1 !== '') {
      address1 = selectedPasssenger.address1;
    }
    if (selectedPasssenger.address2 !== '') {
      address2 = selectedPasssenger.address2;
    }
    if (selectedPasssenger.city !== '') {
      city = selectedPasssenger.city;
    }
    if (selectedPasssenger.zip !== '') {
      zip = selectedPasssenger.zip;
    }
    if (selectedPasssenger.country !== '') {
      country = selectedPasssenger.country;
    }

    if (selectedPasssenger.enableAddressDetail) {
      this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.ContactList.ContactInformation.PostalAddress = {
        Label: 'AddressAtDestination',
        Street: [this.inp_passengerAddressDetail_group_value('address1'), this.inp_passengerAddressDetail_group_value('address2')],
        PostalCode: this.inp_passengerAddressDetail_group_value('zip'),
        CityName: this.inp_passengerAddressDetail_group_value('city'),
        CountryCode: this.inp_passengerAddressDetail_group_value('country')
      };
    } else {
      (this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.ContactList.ContactInformation.PostalAddress = {
        Label: 'AddressAtDestination',
        Street: [address1, address2],
        PostalCode: zip,
        CityName: this.cityName,
        CountryCode: country
      }),
        (this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.ContactList.ContactInformation.ContactProvided = {
          EmailAddress: { EmailAddressValue: this.emailAddress }
        });
    }
    if (selectedPasssenger.enableAddressDetail) {
      this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.ContactList.ContactInformation.ContactNotProvided = '';

      delete this.passengerDetailsUpdateRQ['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.ContactList.ContactInformation.ContactProvided;
    }

    await this.apiService.getXMLResponse(
      this.sandboxPageStateService.ORDER_CHANGE_URL,
      JSON.stringify(this.passengerDetailsUpdateRQ),
      this.reQuoteInputParamsMap,
      {
        headers: new HttpHeaders({
          soapAction: 'OrderChange17_2_V4'
        }),
        responseType: 'text'
      },
      'OrderChange#OrderChangePAX'
    );
    this.updateSandboxPassengerDetail(this.sandboxPageStateService.ORDER_CHANGE_URL);
  }

  updateSandboxPassengerDetail(url: any) {
    let patchSandboxSourceData: any = '';
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      this.showMyMessage = true;
    } else {
      let passengerScreenData = this.sandboxPageStateService.getPassengerDetailScreenData();
      passengerScreenData.xml = this.sandboxPageStateService.getResponseFromMap(url);
      passengerScreenData.jsonData = this.xmlToJsonParserService.parseXMLToJSON(passengerScreenData.xml!);
      passengerScreenData.isMapped = true;

      patchSandboxSourceData = { mainMenu: 'your-booking-screen', sandboxScreen: 'your-booking-screen', sandboxPageSource: passengerScreenData };
      if (this.sandboxPageStateService.getWarningMessage() !== '') {
        patchSandboxSourceData['showWarning'] = 'Yes';
        patchSandboxSourceData['warningMessage'] = this.sandboxPageStateService.getWarningMessage();
      }
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
    this.closePanel();
  }
}
